import { createAction, props } from '@ngrx/store';

export interface ApiCacheEntry {
  data: any;
  requestCount: number;
  refreshInterval: number;
}

// API Cache Actions
export const setApiCacheData = createAction(
  '[API Cache] Set Data',
  props<{ key: string; data: ApiCacheEntry }>()
);

export const clearApiCacheData = createAction(
  '[API Cache] Clear Data',
  props<{ key: string }>()
);

export const clearAllApiCache = createAction('[API Cache] Clear All');

export const incrementRequestCount = createAction(
  '[API Cache] Increment Request Count',
  props<{ key: string }>()
);
